module.exports = __webpack_public_path__ + "static/img/iosCode.b732c533.png";